// Breakpoints exclusivos para la página de Alquiler de Buses
// XL = default (>= 1440px, sin media query)
export const bp = {
  l: "(max-width: 1439px)",
  m: "(max-width: 1023px)",
  s: "(max-width: 767px)",
  xs: "(max-width: 579px)",
}
